/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';
import { MessagesContext } from './MessagesContext';

/**
 * Uses the MessagesContext if one is available.
 *
 * @returns The context from the closes provider
 */
export function useMessagesContext() {
  return useContext(MessagesContext);
}
